module.exports = __webpack_public_path__ + "img/loading.b3d3c06e.svg";